export default "__VITE_ASSET__DJRzgXps__"